let currentCsrfToken: string | null = null;

export const setCsrfTokenForAxios = (token: string | null): void => {
  currentCsrfToken = token;
};

export const getCsrfTokenForAxios = (): string | null => {
  return currentCsrfToken;
};
